import { Typography } from "@mui/material";
import { PopupMessage } from "../PopupMessage";
import { greenColorStyle, redColorStyle } from "./styled";

interface IDisclaimerProps {
  handleClick: () => void,
  context: string,
  time: string
}

export const Disclaimer: React.FC<IDisclaimerProps> = ({ handleClick, context, time }) => (
  <PopupMessage onClose={handleClick} title="More Information">
    <Typography data-automation="page-help-text">
      <Typography component='span' sx={greenColorStyle}>Total Available Employees and Shortages</Typography>, shown in green,
      are updated on demand by clicking on the Refresh button at any time.
      <Typography component='span' sx={redColorStyle}> Job requirements</Typography>, shown in red, are refreshed on a fixed 15 minute schedule.
      Click on the Refresh button after the next scheduled
      refresh time to retrieve the most up-to-date job requirements.
      {context} <Typography component='span' sx={redColorStyle}>{time}</Typography>.
    </Typography>
  </PopupMessage>
);
